import { getCookie } from '@/utils/cookies';
import axios from 'axios';

// Get the API URL from the environment variable
export const apiUrl = import.meta.env.VITE_API_URL;

// Create a config object to store cached values
export const apiConfig = {
  baseURL: `${apiUrl}/api`,
  csrfURL: `${apiUrl}/sanctum/csrf-cookie`,
};

// Create axios instance with the dynamic base URL
export const api = axios.create({
  baseURL: apiConfig.baseURL,
  withCredentials: true,
});

api.interceptors.request.use(
  config => {
    const token = getCookie('XSRF-TOKEN');
    if (token) {
      config.headers['X-XSRF-TOKEN'] = token;
    }
    return config;
  },
  error => Promise.reject(error),
);

export const getCsrfToken = async (): Promise<void> => {
  await axios.get(apiConfig.csrfURL, {
    withCredentials: true,
  });
};
